// extracted by mini-css-extract-plugin
export default {"wrap":"Content_wrap__SN8wC"};